import { object, optional, boolean } from 'superstruct';

export const rewardsAchievementsConfigSchema = object({
  useFullOpacityForIncomplete: optional(boolean()),
});
